export const Loyalty = {
  GOLD_50: 'gold50',
};
